import { Component, OnInit, Injectable } from '@angular/core';
import { RecordsService } from '../services/records.service';
import { FormBuilder } from '@angular/forms';
import { Record } from '../model/record';
import { mergeMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { THIS_EXPR, ConditionalExpr } from '@angular/compiler/src/output/output_ast';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})

@Injectable({
  providedIn: 'root'
})
export class SearchComponent implements OnInit {

  public records: Record;
  public CurrentPage: number = 0;
  public TotalPages: number = 0;
  public TotelElements: number = 0;
  public CurrentTerm: String;
  public CurrentType: String;
  public Links: any;
  public link: string;
  public term: string = '';
  public type: string = 'all';
  public intra: string;
  public shs: boolean = true;
  public lmg: boolean = false;

  constructor(private RecordService:RecordsService) { }

  ngOnInit(): void {
    // this.shs = this.RecordService.shs;
    // this.lmg = this.RecordService.lmg;
    if(this.RecordService.advanced == 'false') this.onGetRecords();
      this.RecordService.getData()
      .subscribe(
        data => {
          this.TotalPages = data.last_page;
          this.CurrentPage = data.current_page;
          this.TotelElements = data.total;
         // console.log(data.total);
          this.Links = data["links"];
          data.data.forEach(function (value) {
            value.status = false;
          });
          
          this.records = data.data;
        }, err => {
          console.log(err);
      }
    );
    this.RecordService.getlocal()
    .subscribe(
      data => {
        this.intra = JSON.stringify(data);
        // console.log(this.intra);
      });
  }

  onGetRecords() {
    this.RecordService.getRecords(this.CurrentPage);
  }


  onPageRecord(page: number) {
    if(page>0 && page<=this.TotalPages)
    {
      this.CurrentPage = page;
      this.RecordService.getRecordsBypage(this.CurrentPage);
    }
  }
  
  Getsearch(term: string, type: string) {
    this.term=term;
    //this.type=type;
    this.RecordService.advanced = 'false';
    this.RecordService.getRecordsByterm(term, type, 0);
  }

  changeShs(e: any) {
    this.shs = e.target.checked;
    this.RecordService.shs = e.target.checked;
    this.RecordService.getRecords(0);
  }

  changeLmg(e: any) {
    this.lmg = e.target.checked;
    this.RecordService.lmg = e.target.checked;
    this.RecordService.getRecords(0);
  }

}
